import { createContext, useContext, type ReactNode } from 'react'
import type { ActionItemLike } from '@/features/purchase-orders/action-audit-model'

/**
 * Lets a page handle an action item from the email that raised it (USA-1417): which email an action card
 * linked to, and how to render the full card under that email.
 */
export const ActionEmailContext = createContext<{
  focusMessageId?: number
  renderAction?: (action: ActionItemLike) => ReactNode
}>({})

export function useActionEmail() {
  return useContext(ActionEmailContext)
}
